export default __webpack_public_path__ + "static/media/action-share.b5365ccf.svg";